import Message from 'components/messages/Message';

import {
	CombinedGraphQLErrors,
	ServerError as ApolloServerError,
} from '@apollo/client';

export default function ErrorMessage({
	title = 'Oisann, noe gikk galt!',
	errors = null,
}) {
	let displayErrors = null;

	if (!errors) return null;

	if (Array.isArray(errors)) {
		displayErrors = errors.filter(error => error);

		if (displayErrors.length == 0) return null;
	} else if (typeof errors === 'object' || typeof errors === 'string') {
		displayErrors = [errors];
	} else {
		return null;
	}

	return (
		<Message title={title} type="error">
			{displayErrors.length === 1 ? (
				<DisplayError error={displayErrors[0]} />
			) : (
				<ul>
					{displayErrors.map((error, i) => {
						return (
							<li key={i}>
								<DisplayError error={error} />
							</li>
						);
					})}
				</ul>
			)}
		</Message>
	);
}

export function DisplayError({ error }) {
	if (typeof error === 'string') {
		return <StringError error={error} />;
	} else if (CombinedGraphQLErrors.is(error)) {
		return <GraphQLError error={error} />;
	} else if (ApolloServerError.is(error)) {
		return <ServerError error={error} />;
	} else if (error.message !== undefined) {
		return <GeneralError error={error} />;
	}

	console.warn('Could not determine error type: ', error);

	return <DefaultError />;
}

function GraphQLError({ error }) {
	const messages = [...new Set(error.errors.map(({ message }) => message))];

	return messages.map(message => <div key={message}>{message}</div>);
}

function ServerError() {
	return (
		<div>
			Noe gikk galt. Prøv igjen, eller kontakt Admento hvis det skjer
			igjen.
		</div>
	);
}

function StringError({ error }) {
	return <div>{error}</div>;
}

function GeneralError({ error }) {
	return <div>{error.message}</div>;
}

function DefaultError() {
	return <div>En uventet feil oppstod!</div>;
}
